import 'bootstrap/dist/css/bootstrap.css';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') ?? undefined;
const rootElement = document.getElementById('container');

ReactDOM.render(
    <BrowserRouter key={"BrowserRouter"} basename={baseUrl}>
        <App />
    </BrowserRouter>,
    rootElement);

serviceWorkerRegistration.unregister();

reportWebVitals();
